<template>
  <div class="main-content-container overflow-hidden">
    <CreateItemVessel />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CreateItemVessel from "@/components/Pages/Management/ItemVessel/CreateItemVessel.vue";

export default defineComponent({
  name: "CreateItemVesselPage",
  components: {
    CreateItemVessel,
  },
});
</script>
